import React from 'react'
import TextComponent from 'components/text' // Assuming this is your custom text component
import './index.css'

const PaperComponent = ({
  title,
  subtitle,
  filterElement,
  className,
  children,
  data_testid,
}: {
  title?: string | React.ReactNode
  subtitle?: string | React.ReactNode
  filterElement?: React.ReactNode
  className?: string
  children?: React.ReactNode
  data_testid?: string
}): JSX.Element => {
  return (
    <div
      data-testid={data_testid}
      className={`bg-white p-4 sm:p-5 rounded-xl border border-gray-200 shadow-sm ${className}`}
    >
      {(title || subtitle || filterElement) && (
        <div className='flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4 mb-4'>
          <div className='w-full sm:w-auto'>
            {typeof title === 'string' ? (
              <TextComponent align='left' size='h6' fontWeight='bold'>
                {title}
              </TextComponent>
            ) : (
              title
            )}
            {subtitle && (
              <TextComponent align='left' fontStyle='italic' size='body2' fontWeight={title ? undefined : 'bold'}>
                {subtitle}
              </TextComponent>
            )}
          </div>
          {filterElement && <div className='w-full sm:w-auto'>{filterElement}</div>}
        </div>
      )}
      {children}
    </div>
  )
}

export default PaperComponent
